import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../../../utils/propUtils';
var VeltCommentsSidebarDocumentFilterDropdownTriggerLabel = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-document-filter-dropdown-trigger-label-wireframe", __assign({}, transformedProps), children));
};
export default VeltCommentsSidebarDocumentFilterDropdownTriggerLabel;
